<div class="desktop-searchbox">
  <div class="flex gap-4">
    <div class="iho-autocomplete w-[35%]">
      <div ihoAutocomplete class="relative">
        <mat-form-field appearance="outline" class="w-full density-settings-0">
          <mat-label class="!text-lg">
            {{searchBoxService.accommodation() == 'ecolodge' ? 'جستجوی شهر، منطقه یا ویلا' : 'مقصد یا هتل'}}
          </mat-label>
          <input matInput class="!font-bold"
            [value]="![undefined, null,'null'].includes(autocompleteService._selectedItem().name) ? autocompleteService._selectedItem().name : ''">
          <mat-icon matPrefix>
            <i class="mr-2 ico-Location text-2xl text-gray-500"></i>
          </mat-icon>
          <small *ngIf="autocompleteValidate" class="text-nowrap text-red-400 absolute -bottom-[24px] -right-[30px]">
            لطفا مقصد خود را انتخاب نمایید
          </small>
        </mat-form-field>
      </div>
      <iho-autocomplete />
    </div>
    <div class="iho-datepicker w-[45%]">
      <div ihoDatepicker class="flex justify-between">
        <mat-form-field appearance="outline" class="w-full m-0 p-0 density-settings-0">
          <mat-label class="!text-lg">
            تاریخ ورود
          </mat-label>
          <input matInput class="!font-bold" readonly autocomplete="off" [value]="datepickerService._customStartDate()">
          <mat-icon matPrefix>
            <i class="mr-2 ico-Calender text-2xl text-gray-500"></i>
          </mat-icon>
        </mat-form-field>
        <div class="mx-2"></div>
        <mat-form-field appearance="outline" class="w-full m-0 p-0 density-settings-0" disabled>
          <mat-label class="!text-lg">
            تاریخ خروج
          </mat-label>
          <input matInput class="!font-bold" readonly autocomplete="off" [value]="datepickerService._customEndDate()">
          <mat-icon matPrefix>
            <i class="mr-2 ico-Calender text-2xl text-gray-500"></i>
          </mat-icon>
        </mat-form-field>
      </div>
      <ng-container *ngComponentOutlet="csrStatus()"></ng-container>
    </div>
    <button (click)="search()" class="w-[20%] bg-blue-500 text-white rounded-lg font-bold">
      جستجو
    </button>
  </div>
</div>